import layers from '../../layers';
import filters from '../filters';
import map from '../map';
import sidebar from '../sidebar';

import dialogs from '../dialog';
import drawing from '../map/draw';
import ConfigurationMapFactory from '../selection/ConfigurationMap';
import Workspace from '../../workspaces';
import { ControlType, Item } from '../../workspaces/item';

const compare = (() => {
    let visible = false;

    let secondView;

    const getPrimaryView = () =>
        $('#map-container');

    const getContainer = () =>
        getPrimaryView().parent();

    const _resizeMap = (width) => {
        if (width === 'auto') {
            getPrimaryView().css({ width });
        } else {
            getPrimaryView().velocity({ width });
        }
    };

    const _toggleView = (width) => {
        if (!secondView) {
            secondView = $('<div class="map-container on-right"></div>');
            getContainer().append(secondView);
        }

        secondView.velocity({
            width
        }, {
            complete () {
                if (width === '50%') {
                    const options = ConfigurationMapFactory.getAvailableOptions();
                    dialogs.select(options, (type) => {
                        Workspace.addAction(new Item(`.btn-action-${type}`, '', ControlType.DialogOption, 1));

                        map.create(secondView[0]);
                        $(secondView).velocity({ top: 53 });

                        if(type === 'copy'){
                            sidebar.copyControls(1);
                            filters.copyFilters(1);
                        }
                    }, () => {
                        map.create(secondView[0]);
                        $(secondView).velocity({ top: 53 });
                    });
                } else {
                    sidebar.removeControls(1);
                    map.remove(1);
                    layers.removeLayers(1);
                    filters.reloadFilters();
                    secondView = undefined;
                }
            }
        });
    };

    const _checkVisibility = () => visible;

    const open = () => {
        if (visible) return;

        visible = true;

        _resizeMap('50%');
        _toggleView('50%');
    };

    const close = () => {
        if (!visible) return;

        visible = false;

        _resizeMap('auto');
        _toggleView('0%');
    };

    const toggle = () => {
        Workspace.addAction(new Item('maptoggle', !visible, ControlType.MapToggle, 1));
        if (visible) {
            close();
        } else {
            open();
        }
    };

    return {
        close,
        open,
        toggle,
        visible: _checkVisibility
    };
})();

export default compare;



// WEBPACK FOOTER //
// ./src/scripts/core/map/compare.js